import { Tabs, Tab } from '@material-ui/core/'
import { useTabStyles, useTabsStyles } from './RestaurantTabs.style.js'
import * as Sentry from '@sentry/react'

const a11yProps = (index) => {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  }
}

const RestaurantTabs = props => {
  const tabsClasses = useTabsStyles()
  const tabClasses = useTabStyles()
  const { restaurantId, restaurants, changeRestaurant } = props
  if (!restaurantId || restaurants.length === 1) {
    return null
  }

  const onChange = (e,v) => {
    changeRestaurant(v)
    Sentry.addBreadcrumb({ category: 'tabHandler', message: `Restaurant switched to ${v}` })
  }

  return <Tabs
    classes = { tabsClasses }
    value={restaurantId}
    onChange={onChange}
    indicatorColor="primary"
    textColor="primary"
    variant="scrollable"
    scrollButtons="auto"
    aria-label="restaurants"
  >
    {
      restaurants.map((restaurant, index) => {
        return <Tab
          classes = { tabClasses }
          key={restaurant.id}
          value={restaurant.id}
          label={ restaurant.attributes.name } {...a11yProps(index)} />
      })
    }
  </Tabs>
}

export default RestaurantTabs
